import {buildNumber, version} from '../../package.json';
export const VERSION = version;
export const DIST = buildNumber;
/*
 * * * * * * * * * * * * * * * *
 * * START PRODUCTION BLOCK  * *
 * * * * * * * * * * * * * * * *
 */

// export const isProduction: boolean = true;
export const TAPI_HTTP = 'https://mobilebackend.amanalabs.net';
// export const CRM_HTTP = 'https://api.crmbox.app';
// export const BACKOFFICE_HTTP = 'https://mobilebackend.amanalabs.net/api/v1';
// export const BACKOFFICE_HTTP_V3 = 'https://mobilebackend.amanalabs.net/api/v3';
export const PRICE_WS = 'wss://mobilebackend.amanalabs.net/market-data';
// export const checkoutPublicKey = 'pk_hrosmjfdjjqwudc3ivfm3ogcwyn';
// export const leanToken = '1d18a5af-cdd7-49e0-9648-92562016130d';
// export const brazeKey = __DEV__
//   ? '0e5c4596-11cf-41df-8be1-56e01c069f25'
//   : '2366f47d-147d-41c7-ad0e-615e3265e9cb';

/*
 * * * * * * * * * * * * * *
 * * START STAGING BLOCK * *
 * * * * * * * * * * * * * *
 */
// export const isProduction = true;
export const CRM_HTTP = 'https://api.fxcrm.io/';
// export const TAPI_HTTP = 'https://api-dev.amanacapital.com';
export const BACKOFFICE_HTTP = 'https://api-dev.amanacapital.com/api/v1';
export const BACKOFFICE_HTTP_V3 = 'https://api-dev.amanacapital.com/api/v3';
export const BACKOFFICE_HTTP_V4 = 'https://api-dev.amanacapital.com/api/v4';
export const checkoutPublicKey = 'pk_sbox_kle3hfoffztvdjt6zj42tiszeae';
export const leanToken = '679d511e-b269-4342-8b7c-e57222ff7814';
export const brazeKey = '0e5c4596-11cf-41df-8be1-56e01c069f25';

/*
 * * * * * * * * * * * * * * *
 * * START LOCALHOST BLOCK * *
 * * * * * * * * * * * * * * *
 */
export const isProduction = false;
// export const CRM_HTTP = 'http://localhost:5172';
// export const TAPI_HTTP = 'http://localhost:8999';
// export const BACKOFFICE_HTTP = 'http://localhost:3001/api/v1';
// export const BACKOFFICE_HTTP_V3 = 'http://localhost:3001/api/v3';
// export const BACKOFFICE_HTTP_V4 = 'http://localhost:3001/api/v4';
// export const PRICE_WS = 'wss://localhost:6789';
// export const C2C_HTTP = 'http://localhost:8999';

// Common exports across all environments
export const GOOGLE_WEB_CLIENT_ID =
  '182007695339-jc1fjnh84pu9m5sllp8u2e9f0d1766gr.apps.googleusercontent.com';
// export const HISTORY_API = 'http://localhost:9999/history-api';
export const HISTORY_API = 'https://mobilebackend.amanalabs.net/history-api';
export const ASSETINFO_API = 'https://airflow.amanacapital.com';
export const CMS_HTTP = 'https://crm.centroidsol.com/api';

export const UAEPASS_ENV = 'staging';
export const UAEPASS_CLIENT_ID = 'sandbox_stage';
export const UAEPASS_WEB_REDIRECT_URI = 'https://mobilebackend.amanalabs.net/auth/callback';
export const UAEPASS_BASE_URL = 'https://stg-id.uaepass.ae';
export const UAEPASS_SCOPE =
  'urn:uae:digitalid:profile:general urn:uae:digitalid:digitalvault:datasharerequest';
export const MAXIMUMDEPOSIT = 6000;

export const IDWISE_DEF_ID = isProduction
  ? 'b7d9e895-7f54-4fdf-bb83-355a297f18d8'
  : '37623880-4d2b-41b5-ba66-01866606a34d';
export const IDWISE_CLIENT_KEY = isProduction
  ? 'QmFzaWMgWWpka09XVTRPVFV0TjJZMU5DMDBabVJtTFdKaU9ETXRNelUxWVRJNU4yWXhPR1E0T2s5bGVIazRTMFJTYVhKWk5XZDBaamRhTTBGVk1VaEtObTlpWW5aSFVsaFJkV3RUT1VVMFRtMD0='
  : 'QmFzaWMgTXpjMk1qTTRPREF0TkdReVlpMDBNV0kxTFdKaE5qWXRNREU0TmpZMk1EWmhNelJrT21jMVVITkpPRWRYVkZwU2VsaFBUa0oxWkdOTVMxbDRWREp1Y0ZOd1JtdG9OSFkwY2sxcWNXWT0=';
